import React from 'react';
import './Brand.less'
class Brand extends React.Component {
	render() {
		let logo
		if (this.props.src) {
			if (window.location.href.includes('hbwl')) {
				logo = <div className="logo" />
			} else {
				logo = <img className="logo" src={this.props.src} alt={this.props.alt} />
			}
		}
		let brand
		if (this.props.href) {
			brand = <a href={this.props.href} alt={this.props.href}>{logo}</a>
		} else {
			brand = logo
		}

		return (
			<div className="brand-box">
				{brand}
			</div>
		);
	}
}

export default Brand;